// This file is kept for backward compatibility
// The main implementation is now in components/MapView/index.jsx

import MapDetailsPage from './components/MapView/index';

export default MapDetailsPage;
